<template>
  <div class="org-card">
    <p class="ico">
      <span>
        <img
          v-if="organization.image === ''"
          src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/ico-3.png"
          alt=""
        />
        <img v-else alt="" :src="organization.image" />
      </span>
    </p>
    <p class="name">{{ organization.name }}</p>
  </div>
</template>

<script>
export default {
  name: "OrgCard",
  props: {
    organization: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped></style>
